import { createContext } from "react";

export default createContext({
  countryCode: "GB",
  language: "en-GB",
  storeCode: "COM",
  keyStoreDataversion: "",
  myAccountUrl: "https://my.asos.com",
  currentUrl: "",
});
